import Iconify from './iconify';
// export type { IconifyProps } from './iconify';

export default Iconify;
